// extracted by mini-css-extract-plugin
export default {"card_grid":"BourbonDetails_card_grid__yLB78"};